import { render, staticRenderFns } from "./Giftcard.vue?vue&type=template&id=1fa3115c"
import script from "./Giftcard.vue?vue&type=script&lang=js"
export * from "./Giftcard.vue?vue&type=script&lang=js"
import style0 from "./Giftcard.vue?vue&type=style&index=0&id=1fa3115c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports